import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { RecruitmentHistoryType } from '../recruitments/Recruitments.types';

export const useGetRecruitmentHistory = (id: string) =>
  useGetFetch<RecruitmentHistoryType>({
    url: pathToUrl(getUrlWithId(ApiRoutesEnum.getRecruitment, id)),
    config: { enabled: !!id },
  });
